import { FuseUtils } from '@fuse/utils';

export class List {
    firstCreation?: boolean;
    id: string;
    name: string;
    description?: string;
    idCards: string[];
    url?: string;

    constructor(list: any) {
        this.id = list.id || FuseUtils.generateGUID();
        this.name = list.name || '';
        this.description = list.description;
        this.idCards = [];
    }
}
